import * as React from "react";
import Ajax from "../../Ajax";
import swal from 'sweetalert';
import TypesList from "./TypesList";
import CheckoutList from "./CheckoutList";
import PlacesList from "./PlacesList";

interface IFormProps {
    setForEdit: any,
    dontAddNew: any
}
interface MyStates {
    ajaxLoaded: boolean,
    session_id: any,
    spinner: string,
    types: object,
    depedencies: any,
    group: boolean,
    booking: boolean,
    meal: boolean,
    services: object,
    cart: Array<object>,
    cartItems: number,
    places: object,
    placesItems: number,
    typesItems: number,
    contact_name: string,
    contact_name_error: boolean,
    phone: string,
    phone_error: boolean,
    email: string,
    email_error: boolean,
    group_name: string,
    group_name_error: boolean,
    purpose_of_arrival: string,
    purpose_of_arrival_error: boolean,
    places_from_date: string,
    places_from_date_error: boolean,
    places_to_date: string,
    places_to_date_error: boolean,
    group_size: number,
    selected_places: object,
    city: string,
    iscompany: boolean,
    isDisabled: boolean,
    payment_method: string,
    churchperson: boolean,
    underage_people_count: number,
    churchpersonnumber: number,
    churchperson_cb_accept: boolean,
    request_for_bed_linen: boolean,
    current_step: string,
    noServicesChecked: Array<boolean>,
    bookingRuleTermLabel: string
}
export default class NewOrder extends React.Component<IFormProps, MyStates>{

    constructor(props:IFormProps) {
        super(props);

        this.state = {
            ajaxLoaded: false,
            session_id: '',
            spinner: 'none',
            types: {},
            depedencies: [],
            group: true,
            booking: false,
            meal: false,
            services: {},
            cart: [],
            cartItems: 0,
            places: {},
            placesItems: 0,
            typesItems: 0,
            contact_name: '',
            contact_name_error: false,
            phone: '',
            phone_error: false,
            email: '',
            email_error: false,
            group_name: '',
            group_name_error: false,
            purpose_of_arrival: '',
            purpose_of_arrival_error: false,
            places_from_date: '',
            places_from_date_error: false,
            places_to_date: '',
            places_to_date_error: false,
            group_size: 1,
            selected_places: {},
            city: '',
            iscompany: false,
            isDisabled: false,
            payment_method: '',
            churchperson: false,
            underage_people_count: 0,
            churchpersonnumber: 0,
            churchperson_cb_accept: false,
            request_for_bed_linen: true,
            current_step: 'orderData',
            noServicesChecked: [],
            bookingRuleTermLabel: ''
        }
        this.getData()
    }

    private getData() {
        var ajax = new Ajax(window.location.origin+ '/api/ordering/getDatasForNew');
        ajax.doPost({company: this.state.iscompany}).then((response) => {
            this.setState({
                ajaxLoaded: true,
                types: response.types,
                session_id: response.session_id,
                typesItems: Math.random(),
                spinner: 'none',
                bookingRuleTermLabel: response.bookingRuleTermLabel
            },() => this.loadCart())
        })
    }

    private loadCart() {

        var ajax = new Ajax(window.location.origin+ '/api/ordering/loadCart');
        ajax.doPost({
            session_id: this.state.session_id,
            group_size: this.state.group_size,
            underage_people_count: this.state.underage_people_count,
            churchpersonnumber: this.state.churchpersonnumber,
            from: this.state.places_from_date,
            to: this.state.places_to_date,
            request_for_bed_linen: this.state.request_for_bed_linen
        }).then((response) => {
            //console.log(response.services);
            this.setState({
                ajaxLoaded: true,
                cart: response.services,
                selected_places: response.places,
                cartItems: Object.keys(response.services).length > 0 ? Math.random() : 0,
                placesItems: Math.random(),
                spinner: 'none'})
        })
    }

    private loadPlaces() {
        if( this.state.places_from_date != '' && this.state.places_to_date != '' ){
            var ajax = new Ajax(window.location.origin+ '/api/ordering/loadPlaces');
            ajax.doPost({
                session_id: this.state.session_id,
                from: this.state.places_from_date,
                to: this.state.places_to_date,
                isdisabled: this.state.isDisabled}).then((response) => {
                if( response.status == 'success' ){
                    this.setState({
                        ajaxLoaded: true,
                        places: response.places,
                        cartItems: Math.random(),
                        placesItems: Math.random(),
                    }, () => this.loadCart())
                } else {
                    swal({
                        title: "Hiba történt!",
                        text: response.message,
                        icon: "error",
                    });
                }
            })
        }
    }
    private updateDates(e, type){
        if( type == 'from'){
            this.setState({places_from_date: e.target.value, places_from_date_error: false}, () => this.loadPlaces())
        }
        if( type == 'to'){
            this.setState({places_to_date: e.target.value, places_to_date_error: false}, () => this.loadPlaces())

            setTimeout(() => {
                this.warningMessage(this.state.group_size);
            }, 3000);

        }
    }

    private handleSubmit(e){
        e.preventDefault();

        this.setState({
            spinner: 'flex',
        }, () => {
            var ajax = new Ajax(window.location.origin+ '/api/ordering/create');
            ajax.doPost('new_order', true).then((response) => {
                if( response.status !== undefined && response.status === 'success' ){
                    swal({
                        title: "Siker!",
                        text: "Foglalási igényét rögzítettük, hamarosan értesítjük!",
                        icon: "success",
                    });
                    this.props.dontAddNew()
                } else {
                    swal({
                        title: "Hiba történt!",
                        text: "Nem sikerült a foglalást leadni!",
                        icon: "error",
                    });
                }
            })
        })
    }

    private setOrderMode(e){
        this.setState({group: e.target.value == 'group' ? true : false})
    }
    private setBooking(e){
        this.setState({booking: e.target.checked}, () => this.loadCart())
    }
    private setMeal(e){
        this.setState({meal: e.target.checked})
    }
    private setGroupSize(e){
        this.warningMessage(e.target.value);
        this.setState({group_size: e.target.value},
            () => this.loadCart())
    }


    public warningMessage(num){
        if(num > 60 && this.state.booking ){
            console.log(this.state.places);
            let sumplaces = 0;
            Object.keys(this.state.places).filter((num) =>this.state.places[num].storey != 'tent_site').map((i) => {
                let p = this.state.places[i]

                sumplaces += p.capacity
            })

            let tentplaces = 0;
            Object.keys(this.state.places).filter((num) =>this.state.places[num].storey == 'tent_site').map((i) => {
                let p = this.state.places[i]

                tentplaces += p.capacity
            })

            swal({
                title: "Figyelem!",
                text: "Az épületben jelenleg " + sumplaces+" fő szálláshelyet tudunk biztosítani, további "+ (num-sumplaces) + " fő vendég részére sátorhely áll rendelkezésre!",
                icon: "warning",
            });
        }
    }

    private setUnderRageCount(e){
        this.setState({underage_people_count: e.target.value}, () => this.loadCart())
    }

    private setChurchPersonCount(e){
        this.setState({churchpersonnumber: e.target.value}, () => this.loadCart())
    }

    private setServices(s){
        this.setState({services: {...this.state.services, s}})
    }
    private removeService(key){
        let services = this.state.services
        delete services[key]
        this.setState({services: services})
    }

    private setZip(e){
        var ajax = new Ajax(window.location.origin+ '/api/ordering/getcity');
        ajax.doPost({zip: e.target.value}).then((response) => {
            this.setState({
                city: response.city,
            })
        })
    }

    private setCity(e){
        this.setState({city: e.target.value});
    }

    private checkPeopleCount(e){
        if(e.target.value > 2){
            swal({
                title: "Hiba történt!",
                text: "Mozgássérült személyből max. 2 fő szállhat meg",
                icon: "error",
            });
        }

        if(e.target.value > 0 && e.target.value <= 2){
            this.setState({isDisabled: true},
                () => this.loadPlaces())
        }

        if(e.target.value == 0 || e.target.value == ''){
            this.setState({isDisabled: false},
                () => this.loadPlaces())
        }
    }

    private isCompany(e){

        this.setState({iscompany: e.target.checked},
            () => this.getData())
    }

    private setPaymentMethod(e){
        this.setState({
            payment_method: e.target.value,
        })
    }

    private setChurchPerson(e){
        if(!e.target.checked){
            this.setState({churchpersonnumber: 0});
        }
        this.setState({churchperson: e.target.checked}, () => this.loadCart());
    }

    private setChurchPersonCbAccept(e){
        this.setState({churchperson_cb_accept: e.target.checked})
    }

    private setRequestForBedLinen(e){
        this.setState({request_for_bed_linen: e.target.checked}, () => this.loadCart())
    }

    private setCurrentStep(step) {
        if (this.state.current_step === step) {
            return;
        }

        if (this.state.current_step === 'orderData') {
            this.checkOrderDataRequiredFields(true);
        }

        this.setState({current_step: step});
    }

    private checkOrderDataRequiredFields(setErrors = false): boolean {
        const requiredFields = [
            'contact_name',
            'phone',
            'email',
            'group_name',
            'purpose_of_arrival',
        ];

        let hasError = false;

        requiredFields.forEach((field: string) => {
            if ((field === 'group_name') && !this.state.group) {
                return;
            }

            const isFilled = this.state[field].length > 0;
            hasError = !isFilled || hasError;

            if (setErrors) {
                if (this.state[`${field}_error`] !== !isFilled) {
                    let change = {};
                    change[`${field}_error`] = !isFilled;
                    this.setState(change);
                }
            }
        });

        if (this.state.booking) {
            const isFromDateFilled = this.state.places_from_date.length > 0;
            if (!isFromDateFilled) {
                hasError = true;
            }
            if (setErrors && this.state.places_from_date_error !== !isFromDateFilled) {
                this.setState({places_from_date_error: !isFromDateFilled});
            }

            const isToDateFilled = this.state.places_to_date.length > 0;
            if (!isToDateFilled) {
                hasError = true;
            }
            if (setErrors && this.state.places_to_date_error !== !isToDateFilled) {
                this.setState({places_to_date_error: !isToDateFilled});
            }
        }

        return !hasError;
    }

    private canMoveNext(currentStep): boolean {

        if (currentStep === 'orderData') {
            const isRequiredFieldsFilled = this.checkOrderDataRequiredFields(false);
            return isRequiredFieldsFilled;
        } else {
            const [_, serial] = currentStep.split('Data');
            const serviceSerial = Number(serial);

            const isNoServicesChecked = this.state.noServicesChecked[serviceSerial] ?? false;
            const hasCartItem = this.state.cart
                .filter((cartItem) => cartItem['service_serial'] == serviceSerial).length > 0;

            return isNoServicesChecked || hasCartItem;
        }

        return true;
    }

    private handleNoServicesChecked(serviceSerial: number, checked: boolean) {
        this.setState((prevState) => {
            let noServicesChecked = prevState.noServicesChecked;
            noServicesChecked[serviceSerial] = checked;
            return { noServicesChecked: noServicesChecked };
        });
    }

    private currentDateString(): string {
        const date = new Date();
        const year = date.getFullYear();

        const month = date.getMonth() + 1;
        const paddedMonth = month < 10 ? `0${month}` : month;

        const day = date.getDate();
        const paddedDay = day < 10 ? `0${day}` : day;

        return `${year}-${paddedMonth}-${paddedDay}`;
    }

    private OrderData(){
        return (
            <>
                <div className="row">
                    <div className={"col-md-6 form-group" + (this.state.contact_name_error ? ' has-error' : '')}>
                        <div className="input-group">
                            <span className="input-group-addon width-130px">
                                Kapcsolattartó:
                            </span>
                            <input type="text" name="contact_name" className="form-control" placeholder="Kapcsolattartó neve" required
                                   onChange={e => this.setState({contact_name: e.target.value, contact_name_error: false})}
                                   onBlur={e => this.checkOrderDataRequiredFields(true)} />
                        </div>
                    </div>
                    <div className="col-md-6 form-group">
                        <div className="input-group">
                            <span className="input-group-addon width-130px">
                                Foglalás módja:
                            </span>
                            <select name="mode" className="form-control" onChange={(e) => this.setOrderMode(e)} required>
                                <option value="group">Csoportos</option>
                                <option value="individual">Egyéni</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className={"col-md-6 form-group" + (this.state.phone_error ? ' has-error' : '')}>
                        <div className="input-group">
                            <span className="input-group-addon width-130px">
                                Telefonszám:
                            </span>
                            <input type="text" name="phone" className="form-control" placeholder="Telefonszám" required
                                   onChange={e => this.setState({phone: e.target.value, phone_error: false})}
                                   onBlur={e => this.checkOrderDataRequiredFields(true)} />
                        </div>
                    </div>
                    <div className={"col-md-6 form-group" + (this.state.email_error ? ' has-error' : '')}>
                        <div className="input-group">
                            <span className="input-group-addon width-130px">
                                E-mail cím:
                            </span>
                            <input type="email" name="email" className="form-control" placeholder="E-mail cím" required
                                   onChange={e => this.setState({email: e.target.value, email_error: false})}
                                   onBlur={e => this.checkOrderDataRequiredFields(true)} />
                        </div>
                    </div>
                </div>

                <div className="row">
                    { this.state.group ?
                        <div className={"col-md-6 form-group" + (this.state.group_name_error ? ' has-error' : '')}>
                            <div className="input-group">
                                <span className="input-group-addon width-130px">
                                    Csoport neve:
                                </span>
                                <input type="text" name="group_name" className="form-control" placeholder="Csoport neve" required
                                       onChange={e => this.setState({group_name: e.target.value, group_name_error: false})}
                                       onBlur={e => this.checkOrderDataRequiredFields(true)} />
                            </div>
                        </div>
                        :<></>
                    }
                    <div className="col-md-6 form-group">
                        <div className="input-group">
                            <span className="input-group-addon width-130px">
                                Létszám:
                            </span>
                            <input type="number" name="group_size"
                                   className="form-control"
                                   onBlur={(e) => this.setGroupSize(e)}
                                   defaultValue="1"
                                   placeholder=""
                                   max={!this.state.booking ? '1000' : '100'}
                            />
                            <span className="input-group-addon">
                                Fő
                            </span>
                        </div>
                    </div>
                </div>

                <hr />
                <div className="row">
                    <div className={"col-md-6 form-group" + (this.state.purpose_of_arrival_error ? ' has-error' : '')}>
                        <div className="input-group">
                            <span className="input-group-addon width-130px">
                                Érkezés célja:
                            </span>
                            <input type = "text" name="purpose_of_arrival" className="form-control"  required
                                   onChange={e => this.setState({purpose_of_arrival: e.target.value, purpose_of_arrival_error: false})}
                                   onBlur={e => this.checkOrderDataRequiredFields(true)} />
                        </div>
                    </div>

                    <div className="col-md-6 form-group">
                        <div className="input-group">
                                <span className="input-group-addon height-34px">
                                    Szeretnék szállást foglalni
                                </span>
                            <span className="input-group-addon">
                                    <input type="checkbox" name="need_booking" defaultChecked={this.state.booking} onChange={(e) => this.setBooking(e)}/>
                                </span>
                        </div>
                    </div>

                </div>

                {
                    this.state.booking ?
                        <>
                            <div className="row">
                                <div className={"col-md-6 form-group" + (this.state.places_from_date_error ? ' has-error' : '')}>
                                    <div className="input-group">
                                    <span className="input-group-addon width-130px">
                                        Érkezés:
                                    </span>
                                        <input type="date" name="arrival_date" className="form-control"
                                               min={this.currentDateString()}
                                               onChange={(e) => this.updateDates(e, 'from')} required
                                               onBlur={e => this.checkOrderDataRequiredFields(true)} />
                                    </div>
                                </div>
                                <div className={"col-md-6 form-group" + (this.state.places_to_date_error ? ' has-error' : '')}>
                                    <div className="input-group">
                                    <span className="input-group-addon width-130px">
                                        Távozás:
                                    </span>
                                        <input type="date" name="departure_date" className="form-control"
                                               min={this.currentDateString()}
                                               onChange={(e) => this.updateDates(e, 'to')} required
                                               onBlur={e => this.checkOrderDataRequiredFields(true)} />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <div className="input-group">
                                    <span className="input-group-addon width-130px">
                                        Mozgássérült:
                                    </span>
                                        <input type="number" name="disabled_people_count" className="form-control" defaultValue="0" max="2" onBlur={(e) => this.checkPeopleCount(e)}/>
                                        <span className="input-group-addon">
                                        fő
                                    </span>
                                    </div>
                                </div>
                                <div className="col-md-6 form-group">
                                    <div className="input-group">
                                    <span className="input-group-addon width-130px">
                                        18 év alatti:
                                    </span>
                                        <input type="number" name="underage_people_count" className="form-control" defaultValue="0" onChange={(e) => this.setUnderRageCount(e)} />
                                        <span className="input-group-addon">
                                        fő
                                    </span>
                                    </div>
                                </div>
                                <div className="col-md-6 form-group">
                                    <div className="input-group">
                                    <span className="input-group-addon height-34px">
                                        Ágynemű igénylés:
                                    </span>
                                        <span className="input-group-addon">
                                        <input type="checkbox" name="request_for_bed_linen" defaultChecked={this.state.request_for_bed_linen} onChange={(e) => this.setRequestForBedLinen(e)}/>
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </>
                        :<></>
                }
                <hr />
                <div className="row">
                    <div className="col-md-6 form-group">
                        <div className="input-group">
                            <span className="input-group-addon height-34px">
                                Jogi személy vagyok:
                            </span>
                            <span className="input-group-addon">
                                <input type="checkbox" name="is_company" defaultChecked={this.state.iscompany} onChange={(e) => this.isCompany(e)} />
                            </span>
                        </div>
                    </div>
                    <div className="col-md-6 form-group">
                        <div className="input-group">
                            <span className="input-group-addon height-34px">
                                Szeretnék étkezést is igénybe venni:
                            </span>
                            <span className="input-group-addon">
                                <input type="checkbox" name="need_meal" defaultChecked={this.state.meal} onChange={(e) => this.setMeal(e)} />
                            </span>
                        </div>
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-md-12 form-group">
                        <div className="input-group">
                            <label>Liturgikus esemény esetén:</label>
                            <textarea className="form-control" name="liturgical_event_comment" placeholder="Érkezik-e a csoporttal klerikus személy aki végzi szertartást, illetve énekes liturgikus esemény esetén érkezik-e kántor a csoporttal? A mező üresen hagyásával automatikusan kérik a helyi klerikus, illetve kántori szolgálatot."></textarea>
                        </div>
                    </div>
                </div>
                { this.state.booking ?
                    <>
                        <h4 className={"text-center"}>Elérhető szállások</h4>
                        <div key={'places_' + this.state.placesItems}>
                            <PlacesList
                                session_id={this.state.session_id}
                                places={this.state.places}
                                selected_places={this.state.selected_places}
                                loadCart={() => this.loadCart()}
                                from={this.state.places_from_date}
                                to={this.state.places_to_date}
                                group_size={this.state.group_size}
                                underage_people_count={this.state.underage_people_count}
                                churchpersonnumber={this.state.churchpersonnumber}
                            />
                        </div>
                    </>
                    :<></>
                }
            </>
        )
    }

    public ServicesData(){
        return (
            <TypesList
                session_id={this.state.session_id}
                types={this.state.types}
                loadCart={() => this.loadCart()}
                onNoServicesChecked={this.handleNoServicesChecked.bind(this)}
                cartItems = {this.state.cart}
            />
        );
    }

    public Checkout(){
        return (
            <div className="box">
                <div className="box-header">
                    <h3 className="box-title">Megrendelés</h3>
                </div>
                <div className="box-body" style={{position: 'relative'}} key={"cart_" + this.state.cartItems}>
                    <CheckoutList session_id={this.state.session_id} cart={this.state.cart} removeService={(e) => this.removeService(e)} loadCart={() => this.loadCart()} />
                </div>
            </div>
        )
    }

    public BillingData(){
        return (
            <div className="box">
                <div className="box-body" style={{position: 'relative'}}>
                    <div className="row">
                        <div className="form-group col-md-6">
                            <div className="input-group">
                                                <span className="input-group-addon width-130px">
                                                    Számlázási név:
                                                </span>
                                <input type="text" name="billing_name" className="form-control" placeholder="Számlázási név" required />
                            </div>
                        </div>

                        <div className="col-md-6 form-group">
                            <div className="input-group">
                                                <span className="input-group-addon width-100px">
                                                    Adószám:
                                                </span>
                                <input type="text" name="billing_tax_number" className="form-control" placeholder="Adószám" required={ this.state.iscompany } />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 form-group">
                            <div className="input-group">
                                                <span className="input-group-addon width-130px">
                                                    Irányítószám:
                                                </span>
                                <input type="number" name="billing_zip" className="form-control" placeholder="Irányítószám" onBlur={(e) => this.setZip(e)} required />
                            </div>
                        </div>
                        <div className="col-md-6 form-group">
                            <div className="input-group">
                                                <span className="input-group-addon width-100px">
                                                    Város:
                                                </span>
                                <input type="text" name="billing_city" className="form-control" value={this.state.city} onChange={(e) => this.setCity(e)} placeholder="Város" required />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <div className="input-group">
                                                <span className="input-group-addon width-130px">
                                                    Közterület:
                                                </span>
                                <input type="text" name="billing_address" className="form-control" placeholder="Közterület" required />
                            </div>
                        </div>
                        <div className="col-md-2 form-group ">
                            <div className="input-group">
                                <select name="billing_address_type" className="form-control" required>
                                    <option value="utca">utca</option>
                                    <option value="út">út</option>
                                    <option value="tér">tér</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-4 form-group">
                            <div className="input-group">
                                                <span className="input-group-addon">
                                                    Házszám:
                                                </span>
                                <input type="text" name="billing_address_number" className="form-control" placeholder="Házszám" required />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <div className="input-group">
                                                <span className="input-group-addon width-130px">
                                                    Ország:
                                                </span>
                                <select name="billing_country" className="form-control" required>
                                    <option value="Magyarország">Magyarország</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-6 form-group">
                            <div className="input-group">
                                                <span className="input-group-addon height-34px">
                                                    Egyházi személy vagyok:
                                                </span>
                                <span className="input-group-addon">
                                                    <input type="checkbox" name="church_person" onChange={(e) => this.setChurchPerson(e)}/>
                                                </span>
                            </div>
                        </div>
                    </div>

                    {this.state.churchperson &&
                        <>
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <div className="input-group">
                                                        <span className="input-group-addon">
                                                            Érkező egyházi személyek száma:
                                                        </span>
                                        <input type="number" name="churchpersonnumber" className="form-control" onChange={(e) => this.setChurchPersonCount(e)} required/>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    <div className="row">
                        <div className="col-md-3 form-group height-34px" style={{textAlign: 'right', width: '130px'}}>
                            Fizetés mód:
                        </div>
                        <div className="col-md-8 form-group">
                            <div className="input-group form-group">
                                                <span className="input-group-addon height-34px">
                                                    Helyszínen készpénzzel vagy bankkártyával 
                                                </span>
                                <span className="input-group-addon">
                                                    <input type="radio" name="payment_method" value="cash" onClick={(e) => this.setPaymentMethod(e)} required />
                                                </span>
                            </div>
                            <div className="input-group form-group">
                                                <span className="input-group-addon height-34px">
                                                    Átutalásos fizetés
                                                </span>
                                <span className="input-group-addon">
                                                    <input type="radio" name="payment_method" value="transfer" onClick={(e) => this.setPaymentMethod(e)} required />
                                                </span>
                            </div>
                            <div className="input-group form-group">
                                                <span className="input-group-addon height-34px">
                                                    Bankkártyás fizetés
                                                </span>
                                <span className="input-group-addon">
                                                    <input type="radio" name="payment_method" value="simplepay" onClick={(e) => this.setPaymentMethod(e)} required />
                                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <textarea className="form-control" name="comment" placeholder="Megjegyzés"></textarea>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            {this.state.churchperson &&
                                <>
                                    <label htmlFor="order_terms">
                                        <input type="checkbox" id="order_terms" name="chruchperson_term" checked={this.state.churchperson_cb_accept} onChange={(e) => this.setChurchPersonCbAccept(e)} required/> Nyilatkozom, hogy megfelelek az alábbiaknak:
                                    </label>
                                    <br/>
                                    <p style={{border:'1px solid #ccc',padding: '10px 10px 10px 20px',borderRadius: '5px'}}>
                                        <b>2011. évi CCVI törvény:</b><br />
                                        12. § * (1) Az egyházi személy a bevett egyház, a bejegyzett egyház, illetve a nyilvántartásba vett egyház belső szabályában meghatározott, az egyházi jogi személy szolgálatában álló, egyházi szolgálatot sajátos egyházi szolgálati viszonyban, munkaviszonyban vagy egyéb jogviszonyban teljesítő természetes személy.
                                    </p>
                                    <br />
                                </>
                            }
                            <label htmlFor="order_terms"><input type="checkbox" id="order_terms" name="terms" required /> Elfogadom a megrendelési feltételeket és az <a target = "_blank" href = "/általános_adatvédelmi_tájékoztató.pdf">adatvédelmi nyilatkozatot.</a></label><br/>
                            <label htmlFor="pilgrimhouse_rule_terms"><input type="checkbox" id="pilgrimhouse_rule_terms" name="pilgrimhouse_rule_terms" required /> Elfogadom a <a target = "_blank" href = "/szentimrehazirend.pdf">Szent Imre Zarándokház házirendjét.</a></label><br/>
                            <label htmlFor="shrine_rule_terms"><input type="checkbox" id="shrine_rule_terms" name="shrine_rule_terms" required /> Elfogadom a <a target = "_blank" href = "/kegyhely_házirend.pdf">Bodajki Segítő Szűz Mária Kegyhely házirendjét.</a></label><br/>

                            <label style = {{display: 'flex',alignItems: 'flex-start'}} htmlFor="booking_rule_terms"><input type="checkbox" id="booking_rule_terms" name="booking_rule_terms" required /> <p style = {{paddingLeft: '5px'}} dangerouslySetInnerHTML={{__html: this.state.bookingRuleTermLabel.replace(/\n/g, "<br />")}}/></label>

                            <br/>
                            {
                                this.state.payment_method == 'simplepay'?
                                    <>
                                        <label htmlFor="simplepay_terms">
                                            <input type="checkbox" id="simplepay_terms" name="simplepay_terms" required /> <small>Tudomásul veszem, hogy a Bodajk Római Katolikus Plébánia – Bodajki Római Katolikus Plébánia Hivatal (8035 Bodajk, Szent István tér 1.) adatkezelő által a(z) http://www.zarandokhaz.plebania-ablak.hu/ felhasználói adatbázisában tárolt alábbi személyes adataim átadásra kerülnek az OTP Mobil Kft. (1143 Budapest, Hungária körút 17-19.), mint adatfeldolgozó részére. Az adatkezelő által továbbított adatok köre az alábbi: név, email cím, számlázási cím, szállítási cím, telefonszám. <br/>Az adatfeldolgozó által végzett adatfeldolgozási tevékenység jellege és célja a SimplePay Adatkezelési tájékoztatóban, az alábbi linken tekinthető meg: <a target = "_blank" href = "https://simplepay.hu/vasarlo-aff">https://simplepay.hu/vasarlo-aff</a></small>
                                        </label><br/>
                                    </>
                                    :<></>
                            }
                            <input type="hidden" name="session_id" defaultValue={this.state.session_id} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <a href="http://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf" target="_BLANK">
                                <img src="/images/simplepay/simplepay_bankcard_logos_left_482x40.png" style={{marginTop: '50px'}} />
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        )
    }

    public CheckoutData(){
        return (
            <>
                {
                    this.state.cartItems > 0 &&
                    <>
                        {this.Checkout()}
                        {this.BillingData()}
                    </>
                }
            </>
        );
    }

    public Buttons(){
        let buttons = [];
        buttons.push('orderData');
        Object.keys(this.state.types).map((i) => {
            if(this.state.types[i].services && this.state.types[i].services.length > 0) {
                buttons.push('servicesData'+i);
            }
        })
        buttons.push('checkoutList');

        return (
            <div className="btns" style = {{float: 'right'}}>
                <a onClick={() => this.setCurrentStep(buttons[buttons.indexOf(this.state.current_step)-1])} href = {'#'+buttons[buttons.indexOf(this.state.current_step)-1]} data-toggle="tab" style = {{marginRight: '10px'}} className={'btn btn-primary btn-lg'}>Vissza</a>
                {
                    this.state.current_step == 'checkoutList' ?
                        <button type="submit" className="btn btn-success btn-lg">Megrendelés elküldése</button> :
                        <a
                            onClick={() => this.setCurrentStep(buttons[buttons.indexOf(this.state.current_step)+1])}
                            href={'#' + buttons[buttons.indexOf(this.state.current_step)+1]}
                            data-toggle="tab"
                            className={"btn btn-success btn-lg" + (this.canMoveNext(this.state.current_step) ? '' : ' disabled')}>
                            Tovább
                        </a>
                }
            </div>
        );
    }

    public render() {
        if( this.state.ajaxLoaded ){

            const numTypes = Object.keys(this.state.types)
                .filter((type) => ((this.state.types[type]['services'] ?? []).length > 0)).length;

            return (
                <>
                    <form id="new_order" onSubmit={(e) => this.handleSubmit(e)}>
                        <div className="row" style = {{display: 'flex', justifyContent:'center'}}>
                            <div className="col-md-7">
                                <div className="panel with-nav-tabs panel-default panel-custom">
                                    <div className="panel-heading">
                                        <ul className="nav nav-tabs" id = "order-tab">
                                            <li className = {this.state.current_step == 'orderData' ? "active" : ""}>
                                                <a onClick={() => this.setCurrentStep('orderData')}
                                                   href="#orderData" data-toggle="tab">Foglalási adatok
                                                </a>
                                            </li>
                                            {
                                                Object.keys(this.state.types).map((i) => {
                                                    const currentStep = `servicesData${i}`;
                                                    const prevStep = (i == '1') ? 'orderData' : `servicesData${Number(i) - 1}`;
                                                    return (
                                                        this.state.types[i].services && this.state.types[i].services.length > 0 &&
                                                        <li className = {this.state.current_step == currentStep ? "active" : ""}
                                                            style={this.canMoveNext(prevStep) ? {} : {pointerEvents: 'none'}}>
                                                            <a onClick={() => this.setCurrentStep(currentStep)}
                                                               className={this.canMoveNext(prevStep) ? '' : 'disabled'}
                                                               href={'#servicesData'+i}
                                                               style={this.canMoveNext(prevStep) ? {} : {color: '#BBB'}}
                                                               data-toggle="tab">
                                                                {this.state.types[i]['name']}
                                                            </a>
                                                        </li>
                                                    )
                                                })
                                            }
                                            <li className = {this.state.current_step == 'checkoutList' ? "active" : ""}
                                                style={this.canMoveNext(`servicesData${numTypes}`) ? {} : {pointerEvents: 'none'}}>
                                                <a onClick={() => this.setCurrentStep('checkoutList')}
                                                   href="#checkoutList"
                                                   style={this.canMoveNext(`servicesData${numTypes}`) ? {} : {color: '#BBB'}}
                                                   data-toggle="tab">
                                                    Megrendelés összesítése
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="panel-body">
                                        <div className="tab-content">
                                            <div className="tab-pane fade active in" id="orderData">
                                                {this.OrderData()}
                                            </div>
                                            {this.ServicesData()}
                                            <div className="tab-pane fade" id="checkoutList">
                                                {this.CheckoutData()}
                                            </div>
                                            {this.Buttons()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {(this.state.cartItems > 0 && this.state.current_step != 'checkoutList') &&
                                <div className="col-md-5">
                                    {this.Checkout()}
                                </div>
                            }
                        </div>
                    </form>
                </>)
        } else {
            return (<>Betöltés</>)
        }
    }
}


